import { css } from "@emotion/css";

export const FloatInput = ({
  placeholder,
  value,
  onChange,
}: {
  placeholder: string;
  value: string;
  onChange: (val: string) => void;
}) => {
  return (
    <div
      className={css`
        flex-grow: 1;
        min-width: 0;

        .input-group {
          width: 100%;
          position: relative;
          margin: 20px 0;
        }

        .input-group label {
          position: absolute;
          top: 50%;
          left: 5px;
          transform: translateY(-50%);
          font-size: 14px;
          color: #ffffff88;
          padding: 0 5px;
          pointer-events: none;
          transition: 0.5s;
        }

        .input-group input {
          width: calc(100% - 20px);
          height: 40px;
          font-size: 14px;
          color: #ffffff;
          padding: 0 10px;
          background-color: transparent;
          border: none;
          border-bottom: 1.2px solid white;
          outline: none;
        }

        .input-group input:focus ~ label,
        .input-group input:valid ~ label,
        .input-group input.invalid ~ label {
          top: 0;
          font-size: 12px;
          background: none;
        }
      `}
    >
      <form action="submit">
        <div className="input-group">
          <input
            type="text"
            id={placeholder}
            name={placeholder}
            required
            value={value}
            onChange={(e) => onChange(e.target.value)}
          />
          <label htmlFor={placeholder}>{placeholder}</label>
        </div>
      </form>
    </div>
  );
};
